exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2HMcI{width:100%;height:90px;overflow:hidden;margin:0 auto;padding:10px 0}._2HMcI>div{width:100%!important;position:absolute;height:100px!important;overflow:hidden;z-index:-10}", ""]);

// exports
exports.locals = {
	"root": "_2HMcI"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/components/Carousel/Carousel.css
// module id = 1054
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13